module.exports = __webpack_public_path__ + "img/5.634620a8.png";